import React, {useEffect, useRef, useState} from "react";
import Config from "../Config";
import token from "../AuthToken";
import {toast} from "react-toastify";
import {Col, Row} from "reactstrap";
import _ from "../Trans";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faInfoCircle,
    faPencil,
    faChevronCircleDown,
    faChevronCircleUp,
    faLocationDot,
    faPeoplePulling
} from "@fortawesome/free-solid-svg-icons";
import Currency from "./Currency";
import CountdownTimer from "./CountdownTimer";
import SquadFinance from "./FinanceModal";
import {NavLink} from "react-router-dom";

const MAX_TEAMS = 3;

const newTeamText = _('New team');

function SquadListEntry({name, selectAnotherTeam, id, isDraftSquad=true}) {
    return <li className="link" onClick={selectAnotherTeam} data-squad-id-position={id}>
        {name}
            {
            isDraftSquad &&
            <FontAwesomeIcon style={{fontSize: 'small', marginLeft: '0.5rem', marginBottom: '0.25rem'}} icon={faPeoplePulling}/>
        }
    </li>
}

function SquadName({squadName, changeSquadName, updateSquad, smallText, extraStyle={}, squads, newTeam, selectAnotherTeam}) {
    const inputRef = useRef(null);
    const [selectTeamIcon, setSelectTeamIcon] = useState(faChevronCircleDown);
    const [displayTeamList, setDisplayTeamList] = useState('none');
    const [edit, setEdit] = useState(false);

    const editSquadName = (e) => setEdit(true);

    const handlePressKey = function (e) {
        if(e.key === "Enter") {
            updateSquad().finally(() => setEdit(false));
        }
    }

    const handleFocusOut = function (e) {
        updateSquad().finally(() => setEdit(false));
    }

    useEffect(() => {if(edit) inputRef.current.focus()}, [edit]);

    const toggleTeamList = function () {
        setDisplayTeamList(displayTeamList === 'none' ? 'block' : 'none');
        setSelectTeamIcon(selectTeamIcon === faChevronCircleUp ? faChevronCircleDown : faChevronCircleUp);
    }

    const triggerSelectAnotherTeam = function(e) {
        toggleTeamList();
        selectAnotherTeam(e);
    }

    return (
        <div>
            <small style={smallText}>
                {Config.multiTeamEnabled ?
                <><FontAwesomeIcon icon={selectTeamIcon} onClick={toggleTeamList}></FontAwesomeIcon> {_("Change Team")}</>
                :
                <>{_("My team")}</>
                }
            </small><br/>
            <ul className="h4 squad-list-entry" style={{display: displayTeamList, zIndex: 1000}}>
                {squads?.map(item => <SquadListEntry key={item.id} name={item.name} selectAnotherTeam={triggerSelectAnotherTeam} id={item.id} isDraftSquad={item.is_draft_mini_league_squad}/>)}
                { squads?.length < MAX_TEAMS && <li onClick={newTeam} className="squad-list-entry-new link">{newTeamText}</li> }
            </ul>
            {edit
                ? (
                    <span>
                        <input value={squadName} className="form-control"
                               ref={inputRef}
                               onChange={changeSquadName}
                               onKeyDown={handlePressKey}
                               onBlur={handleFocusOut}
                        />
                    </span>
                )
                : (
                    <span className="font-weight-bold d-flex justify-content-center pl-0 pr-0 h2" style={extraStyle}>
                        <div className="h2 font-weight-bold" style={{maxWidth: '80vw', overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{squadName}</div>
                        <span onClick={editSquadName} className="link">
                            <FontAwesomeIcon icon={faPencil} className="edit-team-name"/>
                        </span>
                    </span>
                )
            }
        </div>
    )
}

export default function SquadHeader({squadId, name, squad, budget, pointsLastWeek, changeWindow, nextChangeWindowDateStart="", updateSquadHandler, project="supermanager", isMobile, squads, selectAnotherTeam}) {    if(squad !== null) {
        squadId = squad.id;
        name = squad.name;
    }
    const [squadName, setSquadName] = useState(name)
    const [originalSquadName, setOriginalSquadName] = useState(name)
    const [showFinanceModal, setShowFinanceModal] = useState(false);
    const smallText = {'fontSize': (isMobile ? '0.7rem' : '0.9rem')}

    useEffect(() => {
        setSquadName(name)
    }, [name]);

    const changeSquadName = (e) => setSquadName(e.target.value)

    const updateSquad = function (e) {
        let data = {
            name: squadName,
            active: true
        }
        const squadApiUrlUpdate = Config.squadApiUrl + squadId + "/";

        return fetch(squadApiUrlUpdate, {
            method: 'PUT',
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then((e) => {
                if (e.status >= 200 && e.status < 300) {
                    setSquadName(squadName)
                } else {
                    throw new Error(_("Name too long"))
                }
                updateSquadHandler()
                setOriginalSquadName(squadName)
            })
            .catch((e) => {
                console.log(e)
                toast.error(_('Name too long'), Config.toastConfig)
                setSquadName(originalSquadName)
            })
    }

    const newTeam = function() {
        let data = {
            active: true
        }

        return fetch(Config.squadApiUrl, {
            method: 'POST',
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then((e) => {
            if (e.status >= 200 && e.status < 300) {
                // set squad id the returned one
                // set squad stuff
                setSquadName(squadName)
            } else {
                if(e.status === 405) {
                    throw new Error(e.statusText)
                }
                throw new Error(e.error)
            }
            updateSquadHandler()
            setOriginalSquadName(squadName)
        })
        .catch((e) => {
            console.log(e)
            toast.error(e.message, Config.toastConfig)
        })
    }

    const openModal = function() {
        setShowFinanceModal(true)
    }

    const financeIcon = (
        <FontAwesomeIcon icon={faInfoCircle} id="squad-finance-info" onClick={openModal} className="fa-info-circle"/>
    )

    const countdownTimerColor = project === "supermanager" || project === "gremory" ? "#000000" : "#ffffff";
    const linkToRanking = "/ranking/?position=" + squad.this_week_position;

    const mobile = (
        <Row className="squad-header" id="squad-header">
            <Col xs={12} className="text-center">
                <SquadName squadName={squadName} changeSquadName={changeSquadName} updateSquad={updateSquad} smallText={smallText} squads={squads} newTeam={newTeam} selectAnotherTeam={selectAnotherTeam}/>
            </Col>

            <Col xs={6} className="text-center">
                <small style={smallText}>
                    {_("Points from the last day")}
                </small><br/>
                <span className="font-weight-bold h3">
                        {pointsLastWeek}
                </span>
            </Col>

            <SquadFinance squad={squad} show={showFinanceModal} setShow={setShowFinanceModal}></SquadFinance>

            <Col xs={6} className="text-center">
                <small style={smallText}>{_("Budget")}</small><br/>
                <span className="font-weight-bold h3">
                    {false && financeIcon}&nbsp;
                    <Currency value={isNaN(budget) ? 0 : budget}/>
                </span>
            </Col>
            <Col xs={6} className="text-center mt-2">
                <NavLink to={linkToRanking} className="link squad-header-link">
                <small style={smallText}>
                    {_("Last round ranking")}
                </small><br/>
                <span className="font-weight-bold h3">
                     <FontAwesomeIcon icon={faLocationDot} className="ranking-location"/> {squad.this_week_position}º-{squad.total_teams}
                </span>
                </NavLink>
            </Col>

            <Col xs={6} className="text-center mt-2 pl-0 pr-0">
                <small style={smallText}>
                    {_("Transfer window")}
                </small><br/>
                <span className="font-weight-bold h3">
                    <CountdownTimer targetDate={changeWindow} nextChangeWindowDateStart={nextChangeWindowDateStart} color={countdownTimerColor}/>
                </span>
            </Col>
        </Row>
    )

    const desktop = (
        <Row className="squad-header" id="squad-header">
            <Col xs={4} className="text-center">
                <SquadName squadName={squadName} changeSquadName={changeSquadName} updateSquad={updateSquad} smallText={smallText} extraStyle={{padding: '10px 0'}} squads={squads} newTeam={newTeam} selectAnotherTeam={selectAnotherTeam}/>
            </Col>

            <SquadFinance squad={squad} show={showFinanceModal} setShow={setShowFinanceModal}></SquadFinance>
            <Col xs={12} className="mt-2 d-md-none"></Col>

            <Col xs={4} className="text-center">
                <small style={smallText}>
                    {_("Points from the last day")}
                </small><br/>
                <span className="font-weight-bold h5">
                        {pointsLastWeek}
                </span>
                <br/>
                <NavLink to={linkToRanking} className="link squad-header-link">
                <small style={smallText}>
                    {_("Last round ranking")}
                </small><br/>
                <span className="font-weight-bold h5">
                    <FontAwesomeIcon icon={faLocationDot} className="ranking-location"/> {squad.this_week_position}º/{squad.total_teams}
                </span>
                </NavLink>
            </Col>
            <Col xs={4} className="text-center">
                <small style={smallText}>{_("Budget")}</small><br/>
                <span className="font-weight-bold h5">
                    {false && financeIcon}&nbsp;
                    <Currency value={isNaN(budget) ? 0 : budget}/>
                </span>
                <br/>
                <small style={smallText}>
                    {_("Transfer window")}
                </small><br/>
                <span className="font-weight-bold h5">
                    <CountdownTimer targetDate={changeWindow} nextChangeWindowDateStart={nextChangeWindowDateStart} color={countdownTimerColor}/>
                </span>
            </Col>
        </Row>
    )

    return isMobile || (isMobile === undefined && window.innerWidth <= 767) ? mobile :desktop;
}
